import { SITE_ACCESS_STATUS } from "../../../constants/sharepointAccess";
import { updateSiteAccess } from "../sharepointSlice";
import { checkSiteAccess } from "./checkSiteAccess";

export const retrySiteAccess = (siteId) => (dispatch) => {
  dispatch(
    updateSiteAccess([
      {
        id: siteId,
        accessible: null,
        accessStatus: SITE_ACCESS_STATUS.CHECKING,
      },
    ])
  );
  return dispatch(checkSiteAccess());
};
